import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { reflection, background } from './renegades.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/220520/Ltd Editions/renegades-le_woodsy/renegades-le_woodsy_{nnn}.png',
}

export default {
  layers: [background, body, reflection],
  resolveOptions: () => ({
    reflections: 'r5pc',
  }),
}
